/**
 * One blend request, for the QC Supervisor to authorise, reject or blend. First round (2026-09-25):
 * the screen only; nothing is saved yet (docs/PROCESSING_BACKEND.md).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { BlendingAuthorizationPage } from "@/features/processing/components/blending-authorization-page";

export const Route = createFileRoute("/_app/quality/blending/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.verify")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <BlendingAuthorizationPage id={Number(id)} facilityId={selected?.id} />
  );
}
